/*
--------------------------------------------------------------------------------------------------------------
Autor:              EMANUEL GUIVAR
Fecha de creacion:  09/04/2025
Sistema:            Web seguros 
Descripcion:        Inicio del aplicativo
BITACORA DE CAMBIOS 
--------------------------------------------------------------------------------------------------------------
CODIGO      REQ     ANALISTA                    FECHA       MOTIVO
--------------------------------------------------------------------------------------------------------------
*/
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import Helpers from './data/Helpers';


ReactDOM.render(
    <React.StrictMode>
        <BrowserRouter basename={Helpers.UrlBase || '/'}> 
            <App />
        </BrowserRouter>
    </React.StrictMode>,
    document.getElementById('root')
);
